import { Box, useTheme } from "@mui/material"
import { getExpirationColor, getExpirationDate, getExpirationMessage, getExpirationTimeMessage } from "./utils/helpers"

type ExpirationDate = {
  date: string,
  status: number,
  refill: number | null,
}

const ExpirationDate = (props: ExpirationDate) => {
  const { date, status, refill } = props
  const theme = useTheme()

  const dateYear = date ? date.slice(0, 4) : false

  const expirationDate = getExpirationDate(date)
  const formattedDate = expirationDate.format('M/D/YY')

  return (
    <>
      {
        dateYear && dateYear !== '1900' && refill !== 0
          ? (
              <Box sx={{ color: getExpirationColor(status, theme) }}>
                {getExpirationMessage(expirationDate)} {getExpirationTimeMessage(expirationDate)} on {formattedDate}
              </Box>            
            )
          : null
      }
    </>
  )
}

export default ExpirationDate
